<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TR "Gerät wird neu gestartet ..."}}</h4>
</div>

<div class="modal-body">
	<div class="row m-b-15">
		<div class="col-xs-12">
{{#if error}}
			<div class="alert alert-danger">
				{{error}}
			</div>
{{else}}
{{#COMPARE phase '<=' 3}}
			<div class="progress progress-lg">
				<div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuemin="0" aria-valuemax="3"
				{{#COMPARE phase '==' 1}}
				aria-valuenow="0" style="width:  0%;"
				{{/COMPARE}}
				{{#COMPARE phase '==' 2}}
				aria-valuenow="1" style="width: 33%;"
				{{/COMPARE}}
				{{#COMPARE phase '==' 3}}
				aria-valuenow="2" style="width: 66%;"
				{{/COMPARE}}>
				</div>
			</div>
{{/COMPARE}}
		</div>
	</div>
	<div class="row">
		<div class="col-xs-12">
{{#COMPARE phase '==' 1}}
			{{TR "Initialisierung"}}
{{/COMPARE}}
{{#COMPARE phase '==' 2}}
			{{TR "Reset-Kommando senden"}}
{{/COMPARE}}
{{#COMPARE phase '==' 3}}
			{{TR "Warten auf neue Verbindung"}}
{{/COMPARE}}
{{#COMPARE phase '==' 4}}
			<div class="alert alert-success">
				{{TR "Gerät wurde neu gestartet."}}
			</div>
{{else}}
...&nbsp;<i class="fa fa-spin fa-spinner"></i>
{{/COMPARE}}
{{/if}}
		</div>
	</div>
</div>

{{#COMPARE phase '==' 4}}
<div class="modal-footer">
    <button id="ct-cancel" class="btn btn-white" data-dismiss="modal">
        {{TR "Ok"}}
    </button>
</div>
{{/COMPARE}}
